import React from 'react';
import ModalButton from '../UI/ModalButton';
import LanguageSwitcher from '../UI/LanguageSwitcher';
import { useLanguage } from '../../context/LanguageContext';

interface FailedDialogProps {
  onBackToMerchant?: () => void;
}

const FailedDialog: React.FC<FailedDialogProps> = ({
  onBackToMerchant
}) => {
  const { t } = useLanguage();

  const CloseIcon = () => (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 14L42 42M42 14L14 42"
        stroke="#EF4444"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div className="failed-dialog">
      <div className="dialog-header">
        <LanguageSwitcher />
      </div>
      <div className="failed-dialog__content-wrapper">
        <div className="failed-dialog__icon">
          <div className="failed-dialog__icon-inner">
            <CloseIcon />
          </div>
        </div>

        <div className="failed-dialog__content">
          <h2 className="failed-dialog__title">{t('failedTitle')}</h2>
          <p className="failed-dialog__desc">{t('failedDescription')}</p>
          <p className="failed-dialog__hint">{t('failedHint')}</p>
        </div>
      </div>

      {onBackToMerchant && (
        <div className="failed-dialog__actions">
          <ModalButton
            variant="primary"
            onClick={onBackToMerchant}
          >
            {t('backToMerchant')}
          </ModalButton>
        </div>
      )}
    </div>
  );
};

export default FailedDialog;
